import { cn } from '@/lib/utils';
import { useState } from 'react';

import { IImageElement } from '@chainlit/react-client';

import { ImageLightbox } from '@/components/ImageLightbox';

const ImageElement = ({ element }: { element: IImageElement }) => {
  const [lightboxOpen, setLightboxOpen] = useState(false);

  if (!element.url) return null;

  return (
    <>
      <div className="rounded-sm bg-accent overflow-hidden">
        <img
          className={cn(
            'mx-auto block max-w-full h-auto',
            element.display === 'inline' && 'cursor-pointer',
            `${element.display}-image`
          )}
          src={element.url}
          alt={element.name}
          loading="lazy"
          onClick={() => setLightboxOpen(true)}
        />
      </div>

      {/* 共用 lightbox：點擊圖片時打開，集中管理樣式 */}
      <ImageLightbox
        open={lightboxOpen}
        onOpenChange={setLightboxOpen}
        src={element.url}
        alt={element.name}
      />
    </>
  );
};

export { ImageElement };
